import { Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useSubscriptionStatus } from "../../hooks/use-subscription-status";
import { SubscriptionStatusBanner } from "./SubscriptionStatusBanner";

export function SubscriptionProtectedRoute() {
  const { data: status, isLoading } = useSubscriptionStatus();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (status && status.status === "PastDue" && status.organizationStatus === "Inactive") {
    return <Navigate to="/activate-plan" replace />
  }

  return (
    <>
      <SubscriptionStatusBanner />
      <Outlet />
    </>
  );
}